// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { RoleDocument } from "./documents/role-document";
import { ItemEnvelope } from "./base/item-envelope";

export class RoleEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "Role");
		if (jsonEnvelope) {
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public override Document: RoleDocument = new RoleDocument();
	public override get ItemId(): number { return this.Document.Item.RoleId; }
	public override get ItemName(): string { return this.Document.Item.UID; }
}